import React from 'react'
import { Routes, Route } from 'react-router-dom';
import News_event from './News_event';
import Company_news from './Company_news';
import Company_earning from './Company_earning';
import Economy_mktpulse_news from './economy_mktpulse_news';
import Economy_indmkt_news from './economy_indmkt_news';
import Economy_inflation_news from './economy_inflation_news';
import Equity_corporate_news from './equity_corporate_news';
import Equity_corporate_result from './equity_corporate_result';
import Equity_global_news from './equity_global_news';
import Ipo_analysis_news from './ipo_analysis_news';
import Ipo_news from './ipo_news';

const News = () => {
  return (
    <Routes>
    <Route path="/" element={<News_event />} />
    <Route path="company_news" element={<Company_news />} />
    <Route path="company_earning" element={<Company_earning />} />
    <Route path="Economy_mktpulse_news" element={<Economy_mktpulse_news />} />
    <Route path="Economy_indmkt_news" element={<Economy_indmkt_news />} />
    <Route path="Economy_inflation_news" element={<Economy_inflation_news />} />
    <Route path="Equity_corporate_news" element={<Equity_corporate_news />} />
    <Route path="Equity_corporate_result" element={<Equity_corporate_result />} />
    <Route path="Equity_global_news" element={<Equity_global_news />} />
    <Route path="Ipo_analysis_news" element={<Ipo_analysis_news />} />
    <Route path="Ipo_news" element={<Ipo_news />} />
  

    </Routes>
  )
}

export default News




